module.exports = __webpack_public_path__ + "static/media/NoCarryOver.2b4f5120.svg";